import { render, staticRenderFns } from "./DescriptionEdit.vue?vue&type=template&id=4a674a07&scoped=true&"
import script from "./DescriptionEdit.vue?vue&type=script&lang=js&"
export * from "./DescriptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionEdit.vue?vue&type=style&index=0&id=4a674a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a674a07",
  null
  
)

export default component.exports